export default [
  {
    path: 'enter-pin',
    name: 'EnterPinPage',
    component: () => import('./components/EnterPinPage.vue')
  },
  {
    path: 'login',
    name: 'login',
    component: () => import('./LoginPage.vue')
  }
]
